import { render, staticRenderFns } from "./PoiDialog.vue?vue&type=template&id=72a6d8ea&scoped=true"
import script from "./PoiDialog.vue?vue&type=script&lang=js"
export * from "./PoiDialog.vue?vue&type=script&lang=js"
import style0 from "./PoiDialog.vue?vue&type=style&index=0&id=72a6d8ea&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72a6d8ea",
  null
  
)

export default component.exports